// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
export const isValidAmount = (input: string, total: string) => {
  return parseFloat(total) - parseFloat(input) >= 0;
};
